import FormattedText, {
  getPlainText,
  TextNodeType,
} from "../FormattedText/FormattedText";
import {
  BulkBookingCardWrapper,
  ContentCol,
  Description,
  HeaderRow,
  IconCol,
  NewIcon,
  Title,
} from "./BulkBookingPersuasionCard.style";

/** Desktop pageInfo — `bulkBookingPersuasion` */
export interface BulkBookingPersuasionData {
  header?: {
    title?: TextNodeType;
    newIcon?: string;
  };
  description?: TextNodeType;
  icon?: string;
}

interface BulkBookingPersuasionCardProps {
  data?: BulkBookingPersuasionData;
}

const BulkBookingPersuasionCard = ({
  data,
}: BulkBookingPersuasionCardProps) => {
  if (!data) return null;

  const { header, description, icon } = data;
  const title = header?.title;
  const newIcon = header?.newIcon?.trim();
  const iconUrl = icon?.trim();

  const hasTitle = getPlainText(title).trim().length > 0;
  const hasDescription = getPlainText(description).trim().length > 0;

  if (!hasTitle && !hasDescription) return null;

  return (
    <BulkBookingCardWrapper>
      <ContentCol>
        {(hasTitle || newIcon) && (
          <HeaderRow>
            {hasTitle ? (
              <Title>
                <FormattedText value={title} />
              </Title>
            ) : null}
            {newIcon ? <NewIcon src={newIcon} alt="" /> : null}
          </HeaderRow>
        )}
        {hasDescription ? (
          <Description>
            <FormattedText value={description} />
          </Description>
        ) : null}
      </ContentCol>
      {iconUrl ? (
        <IconCol>
          <img src={iconUrl} alt="" />
        </IconCol>
      ) : null}
    </BulkBookingCardWrapper>
  );
};

export default BulkBookingPersuasionCard;
